import React from "react";
import { GlobalNetwork } from "../Networks";
import CAINbig from "../../Images/Experience/min-CAIN-Exp.jpg";
import CAINsmall from "../../Images/Experience/max-CAIN-Exp.jpg";
import NCISbig from "../../Images/Experience/min-NCIS-Exp.jpg";
import NCISsmall from "../../Images/Experience/max-NCIS-Exp.jpg";
import Indabig from "../../Images/Experience/min-India-Exp.jpg";
import Indiasmall from "../../Images/Experience/max-India-Exp.jpg";


const experienceList = [
  {
    name: "Transnational Venture Scalecamp - India",
    subText: "Increase women entrepreneurs' capability to grow ventures in foreign markets",
    url: "/experiences/venture-scalecamp-india",
    banner: {
      big: Indabig,
      small: Indiasmall,
    },
    internal: true,
  },
  {
    name: "Transnational Venture Scalecamp - CIAP",
    subText: "Increase women entrepreneurs' capability to grow ventures",
    url: "/experiences/venture-scalecamp-CIAP",
    banner: {
      big: CAINbig,
      small: CAINsmall,
    },
    internal: true,
  },
  {
    name: "Nigeria-Canada Investment Summit",
    subText: "Fostering strong business partnerships into the future",
    url: "/experiences/ncis-2018-abuja-nigeria",
    banner: {
      big: NCISbig,
      small: NCISsmall,
    },
    internal: true,
  },
];

const cardTheme = {
  textAlign: "left",
  height: "358px",
  maxHeight: "360px",
  backColor: "transparent",
  boxShadow: "none",
  borderRadius: "0.25rem",
  borderTop: "6px solid hsl(217, 53%, 17%)",
  textHoverColor: "hsl(0, 0%, 16%)",
};
export default class Experiences extends React.Component {
  componentDidMount() {
    const images = this.importAll(require.context('../../Images/Experience', false, /\.jpg/));
    console.log(images);
  }
  importAll(r) {
    let images = {};
    r.keys().map((item) => (
      images[item.replace('./','')] = r(item)
    ));
    return images;
  }
  render() {
    return (
      <GlobalNetwork 
        title="Our experiences" 
        minCardWidth="220px" 
        maxCardWidth="310px"
        cardGap="24px"
        cardBodyPad="0 1.5px 5px"
        bgColor="white"
        cards={experienceList}
        theme={cardTheme}
      />      
    );
  }
}

export { cardTheme }



// WEBPACK FOOTER //
// ./src/Components/Experiences/index.js